import environmentHelper from '../utils/environmentHelper';
import storageManager from '../utils/localStorage';
import { AUTH_STORAGE_KEY } from '../utils/apiAuthToken';

const apiConfig = {
  apiUrl: environmentHelper.getHost(),
  authToken: storageManager.get(AUTH_STORAGE_KEY),
  contentType: 'application/json',
  authType: 'Token',
  env: environmentHelper.getEnv()
};

export default apiConfig;
